import { render, staticRenderFns } from "./Instrutor.vue?vue&type=template&id=6b90d812&"
import script from "./Instrutor.vue?vue&type=script&lang=js&"
export * from "./Instrutor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports